import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import WaitingModal from '../../generics/WaitingModal';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import {search} from 'react-icons-kit/icomoon/search';
import {print} from 'react-icons-kit/fa/print';
import {bin} from 'react-icons-kit/icomoon/bin';
import Help from '../../generics/help';
import ModalDetails from './ModalDetails';
var Config = require('../../../config');

class SampleList extends Component{
	constructor(props){
		super(props);
		this.newSample = this.newSample.bind(this);
		this.filter = this.filter.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.printSampleDocument = this.printSampleDocument.bind(this);
		this.getItems = this.getItems.bind(this);
		this.onUpdate = this.onUpdate.bind(this);

		var aux_date = new Date();
		this.state = {
			samples:[],
			filterText:"",
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			start_folio:"",
			end_folio:"",
			columns:[],
		}
	}

	componentDidMount(){
		this.getItems();

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=SAMPLES_REGISTER',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});

	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	getItems(){
		this.props.waiting.handleShow('Cargando...');
		this.setState({samples:[]});
		fetch(Config.default.apiGateway.URL+'samples/samples_register?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id')+'&start_date='+this.state.start_date+
			'&end_date='+this.state.end_date+'&start_folio='+this.state.start_folio+'&end_folio='+this.state.end_folio, {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				response.map((res)=>{
					return res.convoke_place_name !== null ?
						this.setState({
							samples: [...this.state.samples, res]
						})
					: null
				});
			}
		});

	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	newSample(){
		this.props.history.push('/samples/new');
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.donor !== null &&
				row.number !== null &&
				row.sample_type !== null &&
				row.convoke_place_name !== null 
				//row.timestamp !== null 
			){
				
				if(
					row.donor.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.number.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.sample_type.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.convoke_place_name.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 
					//row.timestamp.indexOf(this.state.filterText.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}

		}

		return res;
	}

	async printSampleDocument(e,id){
		e.preventDefault();
		this.waiting_modal.handleShow('Imprimiendo...');
					 
		 var obj ={};
		 obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		 obj.id = id;
		 obj.file_type = 'second_sample';
		 obj.nEtiqueta = [0];

		 var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		this.waiting_modal.handleClose();
		
	}

	onDelete(id, type){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	        	var api = type === 'second_sample_donor' ? 'donors_second_sample/' : 'samples/';

	          	fetch(Config.default.apiGateway.URL+api+id,{ 
		            method: 'delete',
		            headers: new Headers({
		               'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		               'Accept': 'application/json',
		              'Content-Type': 'application/json',
		            })
	          	}).then(res => {
		            if(res.ok){
		              	return res.json();
		            }else{
		              	res.text().then(function(result) {
		                	swal('¡Error!', result, 'error');
		              	});
		            }
		        }).then(res => {
	              	if(res !== undefined){
	                	swal('¡Buen Trabajo!', 'Registro Eliminado','success');
	                	this.getItems();
	              	}
	          	})
	        }
	    }.bind(this));
	}

	showDetails(id){
		this.modal_details.handleShow(id);
	}

	onUpdate(id, type){
		if(type === 'second_sample_donor'){
			this.props.history.push('/second_samples/edit/'+id);
		}else{
			this.props.history.push('/samples/edit/'+id);
		}
		
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');
		
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.donors.MAIN')} ->
						Muestras
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_donors"} 
	                submenu={"help_register_samples"}  />
			                
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Desde</span>
							<input type="date" className="form-control" name="start_date" id="start_date"
								value={this.state.start_date} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Hasta</span>
							<input type="date" className="form-control" name="end_date" id="end_date"
								value={this.state.end_date} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Folio Desde</span>
							<input type="text" className="form-control" name="start_folio" id="start_folio"
								value={this.state.start_folio} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Folio Hasta</span>
							<input type="text" className="form-control" name="end_folio" id="end_folio"
								value={this.state.end_folio} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2" style={{marginTop:"13px"}}>
							<button type="button" className="btn btn-info" onClick={this.getItems} style={{fontSize:"14px"}}>
								Buscar
							</button>
							{this.props.task_donor_samples.create ?
								<button type="button" className="btn btn-info" onClick={this.newSample} style={{fontSize:"14px", marginLeft:"5px"}}>
									Nuevo
								</button>
							:null}
						</div>
						

					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2" style={{marginTop:"20px"}}>
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								id="filterText" value={this.state.filterText} onChange={this.handleChange} />
						</div>
					</div>

					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('DONOR')}>Donador</th>
									<th hidden={this.showColumn('SAMPLE_NUMBER')}>Número de Muestra</th>
									<th hidden={this.showColumn('SAMPLE_TYPE')}>Tipo de Muestra</th>
									<th hidden={this.showColumn('CONVOKE_PLACE')}>Lugar de Colecta</th>
									<th hidden={this.showColumn('REGISTER_DATE')}>Fecha de Registro</th>
									<th hidden={this.showColumn('CONTROLS')}></th>
								</tr>
							</thead>
							<tbody>
								{this.state.samples.map((samp, i)=>{
									return this.filter(samp) ?

										<tr key={i}>
											<td hidden={this.showColumn('DONOR')}>{samp.donor}</td>
											<td hidden={this.showColumn('SAMPLE_NUMBER')}>{samp.number}</td>
											<td hidden={this.showColumn('SAMPLE_TYPE')}>{samp.sample_type}</td>
											<td hidden={this.showColumn('CONVOKE_PLACE')}>{samp.convoke_place_name}</td>
											<td hidden={this.showColumn('REGISTER_DATE')}>{samp.timestamp !== null ? moment(samp.timestamp.split('T')[0], 'YYYY-MM-DD').format('DD/MM/YYYY') : null}</td>
											<td hidden={this.showColumn('CONTROLS')} width="170">
												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
												iconStyle={{height: 33, width: 33}}  
													onClick={this.showDetails.bind(this, (samp.samples_id !== undefined ?
																samp.samples_id : samp.id))} >
													<SvgIcon icon={search} className="icon-align"/>
												</FloatingActionButton>
												<FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} title="Reimprimir" 
													mini={true} style={{marginLeft:"5px"}} 
													onClick={(e) =>this.printSampleDocument(e, samp.id)}>
							                      	<SvgIcon icon={print} className="icon-align"/>
							                    </FloatingActionButton>
						                    	<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}}
												 	onClick={(e) => this.onUpdate(samp.id, samp.type, e)}
												 	disabled={!this.props.task_donor_samples.update}>
													<SvgIcon icon={pencil2} className="icon-align" disabled={!this.props.task_donor_samples.update}/>
												</FloatingActionButton>
												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} onClick={this.onDelete.bind(this, samp.id, samp.type)}
													disabled={!this.props.task_donor_samples.delete}>
													<SvgIcon icon={bin} className="icon-align" disabled={!this.props.task_donor_samples.delete} />
												</FloatingActionButton>
													
							                </td>
										</tr>
									:null
								})}
							</tbody>
						</Table>
					</div>
				</form>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalDetails {...this.props} onRef={ref => (this.modal_details = ref)}/>
			</div>
		)
	}
}

export default translate('translations') (SampleList);